@if (isAuthPingInProgress) {
  <umkt-loading
    [isLoading]="true"
    [size]="'lg'"
    [mode]="'overlay'"
    [showText]="true"
    [text]="'shared.messages.loading' | i18n"
  ></umkt-loading>
} @else {
  @if (!isAuthRoute()) {  
    <umkt-layout>
      <router-outlet></router-outlet>
    </umkt-layout>
  } @else {
    <router-outlet></router-outlet>
  }
}

<umkt-toast></umkt-toast>

<umkt-inactivity-manager></umkt-inactivity-manager>

<umkt-buy-now-redirect-modal
  [isVisible]="buyNowRedirectService.isVisible()"
  [remainingSeconds]="buyNowRedirectService.remainingSeconds()"
  (continueRedirect)="buyNowRedirectService.continueNow()"
  (dismiss)="buyNowRedirectService.dismiss()">
</umkt-buy-now-redirect-modal>
